// Copyright 2005 David Caldwell <david@porkrind.org>

var score_game = require('./score_game');
var lib = require('./lib'), rand=lib.rand, srand=lib.srand;
var plat = require('./platform');
var dom = require('./dom'), doc=dom.doc, px=dom.px, on_load=dom.on_load, URL=dom.URL;
var DrawThreeDSquare = require('./3dsquare');

function img(source, x,y, width, height) {
    var image=document.createElement("IMG");
    image.src="hopeless/"+source;
    image.style.width=px(width);
    image.style.height=px(height);
    image.width=width;
    image.height=height;
    image.style.position="absolute";
    image.style.left=px(x);
    image.style.top=px(y);
    image.style.border="0";
    return image;
}

function Hopeless(board_div, score_div, highscore_div, highscoretabs_div, colors_div, start_div) {
    this.init("hopeless", score_div, highscore_div, highscoretabs_div);
    this.board = board_div;
    this.color_picker = colors_div;
    this.start_button = start_div;
    var me = this;
    this.start_button.onclick = function() { me.new_game(); }
    this.color_picker.onchange = function() {
        if (me.state != "moved")
            me.new_game();
    };

    this.ColorLookup = ["blue.jpeg", "green.jpeg", "cyan.jpeg", "purple.jpeg", "red.jpeg", "yellow.jpeg"];

    this.colors = 4;

    this.blocks = new Array(20);

    this.block = block;
    this.gameover_img = img("gameover.png", 0,0,320, 160);

    this.size = 16;

    if (board_div.tagName.toLowerCase() == 'canvas') {
        this.block = canvas_block;
        this.context = board_div.getContext('2d');
        this.ColorLookup = [
            { r:0x31, g:0x47, b:0xD1 }, // blue.jpeg
            { r:0x31, g:0xd5, b:0x4e }, // green.jpeg
            { r:0x25, g:0xd3, b:0xc9 }, // cyan.jpeg
            { r:0x84, g:0x29, b:0xCE }, // purple.jpeg
            { r:0xDA, g:0x30, b:0x30 }, // red.jpeg
            { r:0xD7, g:0xCF, b:0x24 }, // yellow.jpeg
            { r:0x66, g:0x33, b:0x00 }, // brown
            { r:0xff, g:0x99, b:0x33 }, // orange
            { r:0xff, g:0x99, b:0xff }, // pink
            { r:0x00, g:0x33, b:0x66 }  // navy
        ];
        this.gameover = function(is_gameover) {
            if (is_gameover)
                this.context.drawImage(this.gameover_img,
                                       (this.board.width  - this.gameover_img.width)/2,
                                       (this.board.height - this.gameover_img.height)/2);
        }
        this.resize = function(max_x, max_y) {
            this.size = Math.min(Math.floor(max_x/20),
                                 Math.floor(max_y/10));
            this.board.width  = this.size * 20;
            this.board.height = this.size * 10;
            this.context.clearRect(0, 0, this.board.width, this.board.height);
            for (var x=0; x<this.blocks.length; x++)
                if (this.blocks[x])
                    for (var y=0; y<this.blocks[x].length; y++)
                        if (this.blocks[x][y])
                            this.blocks[x][y].resize(this.size);
            this.gameover(this.state == 'end');
        }
    }
    this.board.style.display="block";
}
Hopeless.prototype = new score_game();

Hopeless.prototype.gameover = function(is_gameover) {
    if (is_gameover == 0) {
        try { this.board.removeChild(this.gameover_img); } catch(e) {} // It might not be there, so catch dom exception.
    } else {
        this.board.appendChild(this.gameover_img);
    }
}

Hopeless.prototype.shuffle_colors = function() {
    for (var i=0; i<this.ColorLookup.length; i++) {
        var x = Math.floor(Math.random()*this.ColorLookup.length);
        var tmp = this.ColorLookup[i];
        this.ColorLookup[i] = this.ColorLookup[x];
        this.ColorLookup[x] = tmp;
    }
}

Hopeless.prototype.random_color = function() {
    return rand() % this.colors;
}

function block(div, color_lookup, color, x, y) {
    this.color = color;
    this.image = img(color_lookup[color], x*16, y*16, 16, 16);
    div.appendChild(this.image);
    return this;
}

block.prototype.move = function(new_x,new_y) {
    this.image.style.left = px(new_x*16);
    this.image.style.top  = px(new_y*16);
}
block.prototype.remove = function() {
    this.image.parentNode.removeChild(this.image);
    delete this.image;
}
block.prototype.set_borders = function(n,s,e,w) { /* Old image based hopeless doesn't get coalescing blocks. */ }

function canvas_block(canvas, color_lookup, color, x, y, size) {
    this.n = this.s = this.e = this.w = 0;
    this.context = canvas.getContext('2d');
    this.color_lookup = color_lookup;
    this.color = color;
    this.x = x;
    this.y = y;
    this.size = size;
    this.draw();
}
canvas_block.prototype.draw = function() {
    DrawThreeDSquare(this.context, this.x*this.size,this.y*this.size,this.size,Math.floor(this.size/7),0,this.color_lookup[this.color], this.n,this.s,this.e,this.w)
}
canvas_block.prototype.remove = function() {
    this.context.clearRect(this.x * this.size, this.y * this.size, this.size, this.size);
}
canvas_block.prototype.move = function(new_x,new_y) {
    this.remove();
    this.x = new_x;
    this.y = new_y;
    this.draw();
}
canvas_block.prototype.resize = function(new_size) {
    this.size = new_size;
    this.draw();
}
canvas_block.prototype.set_borders = function(n,s,e,w) {
    if (this.n == n && this.s == s && this.e == e && this.w == w)
        return;
    this.n=n;
    this.s=s;
    this.e=e;
    this.w=w;
    this.draw();
}

Hopeless.prototype.get_color = function(x,y) {
    return this.blocks[x] != undefined && this.blocks[x][y] ? this.blocks[x][y].color : undefined;
}

Hopeless.prototype.remove = function(x,y) {
    if (this.blocks[x][y]) {
        this.blocks[x][y].remove();
        delete this.blocks[x][y];
    }
}

Hopeless.prototype.remove_all = function() {
    for (var x=0; x<this.blocks.length; x++)
        for (var y=0; y<this.blocks[x].length; y++)
            this.remove(x,y);
}

Hopeless.prototype.remove_block = function(x,y,total) {
    if (!total) total = 1;
    if (this.blocks[x][y] && this.get_color(x,y) != undefined) {
        var color = this.blocks[x][y].color;
        this.blocks[x][y].color = -1;
        if (x>0    && this.get_color(x-1,y) == color) total = this.remove_block(x-1,y,total+1);
        if (x<20-1 && this.get_color(x+1,y) == color) total = this.remove_block(x+1,y,total+1);
        if (y>0    && this.get_color(x,y-1) == color) total = this.remove_block(x,y-1,total+1);
        if (y<10-1 && this.get_color(x,y+1) == color) total = this.remove_block(x,y+1,total+1);
        if (total > 1) {
            this.remove(x,y);
        } else
            this.blocks[x][y].color = color;
    }
    return total;
}

Hopeless.prototype.move_block = function(x,y,x1,y1) {
    this.blocks[x][y] = this.blocks[x1][y1];
    if (this.blocks[x][y]) {
        this.blocks[x][y].move(x,y);
        delete this.blocks[x1][y1];
    }
}

Hopeless.prototype.column_empty = function(x) {
    // This is only a function to work around this bug:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=991457
    return !this.blocks[x][10-1]
}

Hopeless.prototype.collapse_blocks = function() {
    var didSomething=0;
    do {
        didSomething=0;
        for (var x=0; x<this.blocks.length; x++)
            for (var y=1; y<this.blocks[x].length; y++) {
                if (!this.blocks[x][y] && this.blocks[x][y-1]) {
                    this.move_block(x,y,x,y-1);
                    didSomething=1;
                }
            }
    } while (didSomething);

    do {
        didSomething = 0;
        for (var x=0; x<this.blocks.length-1; x++)
            if (this.column_empty(x) && !this.column_empty(x+1)) {
                for (var y=0; y<this.blocks[x].length; y++)
                    this.move_block(x,y,x+1,y);
                didSomething = 1;
            }
    } while (didSomething);
}

Hopeless.prototype.any_moves_left = function() {
    for (var x=0; x<this.blocks.length; x++)
        for (var y=0; y<this.blocks[x].length; y++)
            if (this.get_color(x,y) != undefined && (this.get_color(x,y) == this.get_color(x+1,y) ||
                                                     this.get_color(x,y) == this.get_color(x,y+1)))
                return 1;
    return 0;
}

Hopeless.prototype.coalesce_blocks = function() {
    for (var x=0; x<this.blocks.length; x++)
        for (var y=0; y<this.blocks[x].length; y++)
            if (this.get_color(x,y) != undefined)
                this.blocks[x][y].set_borders(y>0    && this.get_color(x,y) == this.get_color(x,y-1),
                                              y<10-1 && this.get_color(x,y) == this.get_color(x,y+1),
                                              x<20-1 && this.get_color(x,y) == this.get_color(x+1,y),
                                              x>0    && this.get_color(x,y) == this.get_color(x-1,y));
}

//var stats_ = new stats(this.name = name);
Hopeless.prototype.new_game = function(seed) {
    score_game.prototype.new_game.call(this,seed);
    // Encode number of colors into bottom bits (so with one number we can recreate the game)
    if (seed == undefined) this.seed = this.seed & 0x7ffffff0 | (parseInt(this.color_picker.value)-1);
    srand(this.seed); // re-srand() since we might have just changed the seed.

    this.stats.set("seed", this.seed);
    this.stats.set("game_id", this.game_id);
    this.stats.set("colors", this.colors);

    this.shuffle_colors();
    this.colors = (this.seed & 0xf) % 6 + 1;

    if (this.blocks[0]) this.remove_all();
    this.gameover(false);
    for (var x=0; x<this.blocks.length; x++) {
        this.blocks[x] = new Array(10);
        for (var y=0; y<this.blocks[x].length; y++) {
            this.blocks[x][y] = new this.block(this.board, this.ColorLookup, this.random_color(),x,y, this.size);
        }
    }
    if (!URL.param.nc)
        this.coalesce_blocks();
    this.state = "new";

    var me = this;
    this.board.onclick = function(event) {
        var e = new plat.event(event, me.board), x, y;
        var removed = me.remove_block(x=Math.floor(e.targetX/me.size), y=Math.floor(e.targetY/me.size));
        if (removed < 2) return;
        var increase = removed * removed;
        if (me.colors > 2)
            increase *= me.colors;
        else
            increase /= 50/me.colors;
        me.score.inc(Math.floor(increase));

        me.stats.push("move", { x:x, y:y });
        me.state = "moved";
        me.collapse_blocks();
        if (!URL.param.nc)
            me.coalesce_blocks();
        if (!me.any_moves_left()) {
            me.board.onclick = null;
            me.gameover(true);
            me.end_game();
            me.state = "end";
        }
    }
}

//plat.has_canvas = false;
var the_game = new Hopeless(plat.has_canvas ? doc.id("canvas_board") : doc.id("board"),
                            doc.id("score"),
                            doc.id("global_high_score"),
                            doc.id("scoretab"),
                            doc.id("colors"),
                            doc.id("start"));

if (plat.has_canvas) {
    doc.id("board_area").style.display = "block";

    window.onresize = function() {
        var wrapper = doc.id("canvas_wrapper");
        the_game.resize(wrapper.clientWidth,
                        wrapper.clientHeight);
    }
}

on_load(function () {
    if (window.onresize)
        window.onresize();
    the_game.new_game(URL.param.game);
});

require('./gotd').start = function(game_of_the_day) { the_game.new_game(game_of_the_day) };
// Copyright 2005 David Caldwell <david@porkrind.org>

var score_game = require('./score_game');
var lib = require('./lib'), rand=lib.rand, srand=lib.srand;
var plat = require('./platform');
var dom = require('./dom'), doc=dom.doc, px=dom.px, on_load=dom.on_load, URL=dom.URL;
var DrawThreeDSquare = require('./3dsquare');

function img(source, x,y, width, height) {
    var image=document.createElement("IMG");
    image.src="hopeless/"+source;
    image.style.width=px(width);
    image.style.height=px(height);
    image.width=width;
    image.height=height;
    image.style.position="absolute";
    image.style.left=px(x);
    image.style.top=px(y);
    image.style.border="0";
    return image;
}

function Hopeless(board_div, score_div, highscore_div, highscoretabs_div, colors_div, start_div) {
    this.init("hopeless", score_div, highscore_div, highscoretabs_div);
    this.board = board_div;
    this.color_picker = colors_div;
    this.start_button = start_div;
    var me = this;
    this.start_button.onclick = function() { me.new_game(); }
    this.color_picker.onchange = function() {
        if (me.state != "moved")
            me.new_game();
    };

    this.ColorLookup = ["blue.jpeg", "green.jpeg", "cyan.jpeg", "purple.jpeg", "red.jpeg", "yellow.jpeg"];

    this.colors = 4;

    this.blocks = new Array(20);

    this.block = block;
    this.gameover_img = img("gameover.png", 0,0,320, 160);

    this.size = 16;

    if (board_div.tagName.toLowerCase() == 'canvas') {
        this.block = canvas_block;
        this.context = board_div.getContext('2d');
        this.ColorLookup = [
            { r:0x31, g:0x47, b:0xD1 }, // blue.jpeg
            { r:0x31, g:0xd5, b:0x4e }, // green.jpeg
            { r:0x25, g:0xd3, b:0xc9 }, // cyan.jpeg
            { r:0x84, g:0x29, b:0xCE }, // purple.jpeg
            { r:0xDA, g:0x30, b:0x30 }, // red.jpeg
            { r:0xD7, g:0xCF, b:0x24 }, // yellow.jpeg
            { r:0x66, g:0x33, b:0x00 }, // brown
            { r:0xff, g:0x99, b:0x33 }, // orange
            { r:0xff, g:0x99, b:0xff }, // pink
            { r:0x00, g:0x33, b:0x66 }  // navy
        ];
        this.gameover = function(is_gameover) {
            if (is_gameover)
                this.context.drawImage(this.gameover_img,
                                       (this.board.width  - this.gameover_img.width)/2,
                                       (this.board.height - this.gameover_img.height)/2);
        }
        this.resize = function(max_x, max_y) {
            this.size = Math.min(Math.floor(max_x/20),
                                 Math.floor(max_y/10));
            this.board.width  = this.size * 20;
            this.board.height = this.size * 10;
            this.context.clearRect(0, 0, this.board.width, this.board.height);
            for (var x=0; x<this.blocks.length; x++)
                if (this.blocks[x])
                    for (var y=0; y<this.blocks[x].length; y++)
                        if (this.blocks[x][y])
                            this.blocks[x][y].resize(this.size);
            this.gameover(this.state == 'end');
        }
    }
    this.board.style.display="block";
}
Hopeless.prototype = new score_game();

Hopeless.prototype.gameover = function(is_gameover) {
    if (is_gameover == 0) {
        try { this.board.removeChild(this.gameover_img); } catch(e) {} // It might not be there, so catch dom exception.
    } else {
        this.board.appendChild(this.gameover_img);
    }
}

Hopeless.prototype.shuffle_colors = function() {
    for (var i=0; i<this.ColorLookup.length; i++) {
        var x = Math.floor(Math.random()*this.ColorLookup.length);
        var tmp = this.ColorLookup[i];
        this.ColorLookup[i] = this.ColorLookup[x];
        this.ColorLookup[x] = tmp;
    }
}

Hopeless.prototype.random_color = function() {
    return rand() % this.colors;
}

function block(div, color_lookup, color, x, y) {
    this.color = color;
    this.image = img(color_lookup[color], x*16, y*16, 16, 16);
    div.appendChild(this.image);
    return this;
}

block.prototype.move = function(new_x,new_y) {
    this.image.style.left = px(new_x*16);
    this.image.style.top  = px(new_y*16);
}
block.prototype.remove = function() {
    this.image.parentNode.removeChild(this.image);
    delete this.image;
}
block.prototype.set_borders = function(n,s,e,w) { /* Old image based hopeless doesn't get coalescing blocks. */ }

function canvas_block(canvas, color_lookup, color, x, y, size) {
    this.n = this.s = this.e = this.w = 0;
    this.context = canvas.getContext('2d');
    this.color_lookup = color_lookup;
    this.color = color;
    this.x = x;
    this.y = y;
    this.size = size;
    this.draw();
}
canvas_block.prototype.draw = function() {
    DrawThreeDSquare(this.context, this.x*this.size,this.y*this.size,this.size,Math.floor(this.size/7),0,this.color_lookup[this.color], this.n,this.s,this.e,this.w)
}
canvas_block.prototype.remove = function() {
    this.context.clearRect(this.x * this.size, this.y * this.size, this.size, this.size);
}
canvas_block.prototype.move = function(new_x,new_y) {
    this.remove();
    this.x = new_x;
    this.y = new_y;
    this.draw();
}
canvas_block.prototype.resize = function(new_size) {
    this.size = new_size;
    this.draw();
}
canvas_block.prototype.set_borders = function(n,s,e,w) {
    if (this.n == n && this.s == s && this.e == e && this.w == w)
        return;
    this.n=n;
    this.s=s;
    this.e=e;
    this.w=w;
    this.draw();
}

Hopeless.prototype.get_color = function(x,y) {
    return this.blocks[x] != undefined && this.blocks[x][y] ? this.blocks[x][y].color : undefined;
}

Hopeless.prototype.remove = function(x,y) {
    if (this.blocks[x][y]) {
        this.blocks[x][y].remove();
        delete this.blocks[x][y];
    }
}

Hopeless.prototype.remove_all = function() {
    for (var x=0; x<this.blocks.length; x++)
        for (var y=0; y<this.blocks[x].length; y++)
            this.remove(x,y);
}

Hopeless.prototype.remove_block = function(x,y,total) {
    if (!total) total = 1;
    if (this.blocks[x][y] && this.get_color(x,y) != undefined) {
        var color = this.blocks[x][y].color;
        this.blocks[x][y].color = -1;
        if (x>0    && this.get_color(x-1,y) == color) total = this.remove_block(x-1,y,total+1);
        if (x<20-1 && this.get_color(x+1,y) == color) total = this.remove_block(x+1,y,total+1);
        if (y>0    && this.get_color(x,y-1) == color) total = this.remove_block(x,y-1,total+1);
        if (y<10-1 && this.get_color(x,y+1) == color) total = this.remove_block(x,y+1,total+1);
        if (total > 1) {
            this.remove(x,y);
        } else
            this.blocks[x][y].color = color;
    }
    return total;
}

Hopeless.prototype.move_block = function(x,y,x1,y1) {
    this.blocks[x][y] = this.blocks[x1][y1];
    if (this.blocks[x][y]) {
        this.blocks[x][y].move(x,y);
        delete this.blocks[x1][y1];
    }
}

Hopeless.prototype.column_empty = function(x) {
    // This is only a function to work around this bug:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=991457
    return !this.blocks[x][10-1]
}

Hopeless.prototype.collapse_blocks = function() {
    var didSomething=0;
    do {
        didSomething=0;
        for (var x=0; x<this.blocks.length; x++)
            for (var y=1; y<this.blocks[x].length; y++) {
                if (!this.blocks[x][y] && this.blocks[x][y-1]) {
                    this.move_block(x,y,x,y-1);
                    didSomething=1;
                }
            }
    } while (didSomething);

    do {
        didSomething = 0;
        for (var x=0; x<this.blocks.length-1; x++)
            if (this.column_empty(x) && !this.column_empty(x+1)) {
                for (var y=0; y<this.blocks[x].length; y++)
                    this.move_block(x,y,x+1,y);
                didSomething = 1;
            }
    } while (didSomething);
}

Hopeless.prototype.any_moves_left = function() {
    for (var x=0; x<this.blocks.length; x++)
        for (var y=0; y<this.blocks[x].length; y++)
            if (this.get_color(x,y) != undefined && (this.get_color(x,y) == this.get_color(x+1,y) ||
                                                     this.get_color(x,y) == this.get_color(x,y+1)))
                return 1;
    return 0;
}

Hopeless.prototype.coalesce_blocks = function() {
    for (var x=0; x<this.blocks.length; x++)
        for (var y=0; y<this.blocks[x].length; y++)
            if (this.get_color(x,y) != undefined)
                this.blocks[x][y].set_borders(y>0    && this.get_color(x,y) == this.get_color(x,y-1),
                                              y<10-1 && this.get_color(x,y) == this.get_color(x,y+1),
                                              x<20-1 && this.get_color(x,y) == this.get_color(x+1,y),
                                              x>0    && this.get_color(x,y) == this.get_color(x-1,y));
}

//var stats_ = new stats(this.name = name);
Hopeless.prototype.new_game = function(seed) {
    score_game.prototype.new_game.call(this,seed);
    // Encode number of colors into bottom bits (so with one number we can recreate the game)
    if (seed == undefined) this.seed = this.seed & 0x7ffffff0 | (parseInt(this.color_picker.value)-1);
    srand(this.seed); // re-srand() since we might have just changed the seed.

    this.stats.set("seed", this.seed);
    this.stats.set("game_id", this.game_id);
    this.stats.set("colors", this.colors);

    this.shuffle_colors();
    this.colors = (this.seed & 0xf) % 6 + 1;

    if (this.blocks[0]) this.remove_all();
    this.gameover(false);
    for (var x=0; x<this.blocks.length; x++) {
        this.blocks[x] = new Array(10);
        for (var y=0; y<this.blocks[x].length; y++) {
            this.blocks[x][y] = new this.block(this.board, this.ColorLookup, this.random_color(),x,y, this.size);
        }
    }
    if (!URL.param.nc)
        this.coalesce_blocks();
    this.state = "new";

    var me = this;
    this.board.onclick = function(event) {
        var e = new plat.event(event, me.board), x, y;
        var removed = me.remove_block(x=Math.floor(e.targetX/me.size), y=Math.floor(e.targetY/me.size));
        if (removed < 2) return;
        var increase = removed * removed;
        if (me.colors > 2)
            increase *= me.colors;
        else
            increase /= 50/me.colors;
        me.score.inc(Math.floor(increase));

        me.stats.push("move", { x:x, y:y });
        me.state = "moved";
        me.collapse_blocks();
        if (!URL.param.nc)
            me.coalesce_blocks();
        if (!me.any_moves_left()) {
            me.board.onclick = null;
            me.gameover(true);
            me.end_game();
            me.state = "end";
        }
    }
}

//plat.has_canvas = false;
var the_game = new Hopeless(plat.has_canvas ? doc.id("canvas_board") : doc.id("board"),
                            doc.id("score"),
                            doc.id("global_high_score"),
                            doc.id("scoretab"),
                            doc.id("colors"),
                            doc.id("start"));

if (plat.has_canvas) {
    doc.id("board_area").style.display = "block";

    window.onresize = function() {
        var wrapper = doc.id("canvas_wrapper");
        the_game.resize(wrapper.clientWidth,
                        wrapper.clientHeight);
    }
}

on_load(function () {
    if (window.onresize)
        window.onresize();
    the_game.new_game(URL.param.game);
});

require('./gotd').start = function(game_of_the_day) { the_game.new_game(game_of_the_day) };
